import React from 'react';
import classnames from 'classnames';
import './style.less'

interface TaobaoFormItemProps {
  children: React.ReactNode,
  style?: React.CSSProperties,
  label?: string | React.ReactNode,
  className?: string,
}

const clsPrefix = 'c-tb-form-item';
const TaobaoFormItem:React.FC<TaobaoFormItemProps> = ({
  children,
  style = {},
  className,
  label
}) => {
  return (
    <div className={classnames(clsPrefix, className)} style={{...style}}>
      <div className={`${clsPrefix}__title`}>{label}</div>
      {children}
    </div>
  )
}

export default TaobaoFormItem;